import { apiClient } from './api'
import { resolveEventId } from './eventService'

export interface Sponsor {
  id: string
  name: string
  tier?: string | null
  tierOrdinal: number
  ordinal: number
  logoUrl?: string | null
  websiteUrl?: string | null
  description?: string | null
  booth?: string | null
}

export const sponsorsService = {
  list: async (): Promise<Sponsor[]> => {
    const id = await resolveEventId()
    return apiClient.get<Sponsor[]>(`/events/${id}/sponsors`).then((r) => r.data)
  },
  toggleInterest: async (sponsorId: string): Promise<{ interested: boolean }> => {
    const id = await resolveEventId()
    return apiClient
      .post<{ interested: boolean }>(`/events/${id}/sponsors/${sponsorId}/interest`)
      .then((r) => r.data)
  },
}
